import React from 'react';
import sanitizeHtml from 'sanitize-html';

import {
  Card,
  Text
} from 'components';
import { observer } from 'mobx-react-lite';
import { translate, translationExists } from 'utils/helpers';

export const CardMessages = observer(() => {
  if (!translationExists('pageHome.cardMessages.content')) {
    return null;
  }

  return (
    <Card
      background="var(--tecnea-blue-light)"
      maxWidth="none"
      title={translate('pageHome.cardMessages.title')}
      titleColor="var(--black)"
    >
      <Text color="var(--black)" fontSize="1.8rem" margin="0">
        <span dangerouslySetInnerHTML={
            { __html: sanitizeHtml(translate('pageHome.cardMessages.content')) }
        }/>
      </Text>
    </Card>
  );
});
